import qs from 'query-string'
import React from 'react'
import PropTypes from 'prop-types'

import { Box, Divider, Link, Text } from 'pcln-design-system'

import { CruisesSearchContainer } from '@pcln/home-components'

// TODO: SETI clean up for HP_BUTTON_COLOR
import CruisesSearchForm from '../search-forms/CruisesSearchForm'

import * as PCLNAnalytics from '../../utils/PCLN-Analytics'
import withAnalytics from './withAnalytics'

const formatCruisesURL = ({
  location,
  cruiseLine,
  zip,
  startDate,
  duration,
  underFiftyFive = undefined
}, referral) => {
  // TODO: follow up to improve explicitly string comparision with 'true' or 'false'
  const lowerUnderFiftyFive =
    typeof underFiftyFive === 'string' && underFiftyFive.toLowerCase()
  const parsedUnderFiftyFive = lowerUnderFiftyFive === 'true'
  const query =
    '?' +
    qs.stringify({
      places: location,
      operator: cruiseLine,
      Month: startDate,
      days: duration,
      shoppingZipCode: zip,
      IncludeSeniorRates: parsedUnderFiftyFive,
      sort_by: 7,
      refId: referral.id,
      refClickId: referral.clickId
    })
  return '//cruises.priceline.com/results.do' + query
}

const CruisesBumper = () => (
  <Text>
    Get up to $1,000 to spend at sea when you&nbsp;
    <Text.span fontWeight='bold' color='primary'>
      <Link
        href='https://cruises.priceline.com?utm_medium=partner_site_banner&utm_source=pcln-partner_site&utm_campaign=20190307&utm_content=widget_link'
        target='_blank'
      >
        book a cruise with Priceline.
      </Link>
    </Text.span>
  </Text>
)

const Cruises = withAnalytics({
  action: '',
  events: {}
})(
  class extends React.Component {
    static propTypes = {
      onSubmit: PropTypes.func,
      referral: PropTypes.object
    }

    handleSubmit = values => {
      const { onSubmit, referral } = this.props
      const url = formatCruisesURL(values, referral)
      onSubmit(url)
      const data = [
        `Destination_${values.location}`,
        `Cruise line_${values.cruiseLine}`,
        `Zip Code_${values.zip}`,
        `Departure Date ${values.startDate}`,
        `Cruise Length_${values.duration}`,
        `55 years or older_${values.underFiftyFive ? 'N' : 'Y'}`
      ].join('|')
      PCLNAnalytics.send({
        action: 'Cruises Search Button',
        data
      })
      PCLNAnalytics.send({
        action: 'Cruises Search',
        data: 'Valid'
      })
    }

    render () {
      return (
        <Box>
          <Box p={3}>
            <CruisesSearchContainer
              {...this.props}
              onSubmit={this.handleSubmit}
              render={props => <CruisesSearchForm {...props} />}
            />
          </Box>
          <Divider my={0} />
          <Box
            px={3}
            py={3}
            style={{
              height: 48,
              borderBottomRightRadius: '6px',
              borderBottomLeftRadius: '6px'
            }}
            color='background.light'
          >
            <Text fontSize={1} textAlign='center' color='text.light'>
              <CruisesBumper />
            </Text>
          </Box>
        </Box>
      )
    }
  }
)

export default Cruises
